import styled from 'styled-components'

const ImgEdit = styled.img`
  opacity: 0;
  transition: opacity 0.2s;
  cursor: pointer;
`

const Style = {
	RankingCell: styled.div`
		display: flex;
		flex-direction: column;
		gap: 6px;
		position: relative;
	`,
	RankDisplay: styled.div`
		display: flex;
    align-items: center;
    gap: 8px;

		& > span {
			${({theme}) => theme.font.extra_small};
		}
    
    &:hover ${ImgEdit} {
      opacity: 1;
    }
	`,
	ImgEdit,
	EditForm: styled.div`
		display: flex;
    align-items: center;
    gap: 4px;
	`,
	RankInput: styled.input`
		width: 50px;
		height: 26px;
		padding: 6px;
		border: 1px solid ${({ theme, $rankError }) => ($rankError ? theme.color.major : theme.color.grey3)};
		border-radius: 4px;
		${({theme}) => theme.font.extra_small};
		line-height: 3;

		&::-webkit-outer-spin-button,
		&::-webkit-inner-spin-button {
				-webkit-appearance: none;
				margin: 0;
		}
		
		&[type=number] {
				-moz-appearance: textfield;
		}
	`,
	ErrorMessage: styled.p`
		position: absolute;
    bottom: -14px;
    left: 0;
		${({theme}) => theme.font.extra_small};
		color: ${({ theme }) => theme.color.major};
		font-size: 8px;
	`,
}

export default Style
